import type { SafePromise } from '@benzinga/safe-await';
import { ExtendedSubscribable } from '@benzinga/subscribable';
import type { Session } from '@benzinga/session';

import type { EdgeContentResponse } from './entities';
import { EdgeRequest, type EdgeRequestEvent } from './request';

export type EdgeManagerEvent = EdgeRequestEvent;

interface EdgeFunctions {
  getEdgeContent: EdgeManager['getEdgeContent'];
}

export class EdgeManager extends ExtendedSubscribable<EdgeManagerEvent, EdgeFunctions> {
  private request: EdgeRequest;

  constructor(session: Session) {
    super();
    this.request = new EdgeRequest(session);
  }

  public static getName = () => 'benzinga-edge';

  public getEdgeContent = async (): SafePromise<EdgeContentResponse> => {
    return await this.request.getEdgeContent();
  };

  protected onSubscribe(): EdgeFunctions {
    return {
      getEdgeContent: this.getEdgeContent,
    };
  }
}
